exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".animatedNumber[data-v-2d80cdb9]{font-family:Open Sans}", ""]);

// exports
